// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkbox {
  padding-bottom: 15px; }

.conflictResolutionContent {
  overflow: hidden; }

#coloredContainer {
  display: inline-flex;
  width: 100%;
  height: 54px;
  background-color: #f9f9f9;
  margin-bottom: 15px;
  max-width: 558px; }

#conflictingItemIcon {
  position: relative;
  top: 10px;
  left: 8px;
  padding-right: 12px; }

#conflictItemName {
  width: 100%;
  padding-top: 8px; }

#conflictContainer {
  display: inline-flex; }

#conflictItemDataEntry {
  display: inline-flex;
  padding-right: 12px;
  font-size: 12px;
  font-family: 'Open Sans';
  font-weight: 400;
  font-style: normal;
  font-size: 12px;
  color: #666666; }

#conflictContainer {
  width: 88%;
  display: inline-block; }

#smallerText {
  padding-left: 20px;
  font-family: 'Open Sans';
  font-weight: 400;
  font-style: normal;
  font-size: 12px;
  color: #666666;
  padding-bottom: 15px; }

#line {
  border: 1px solid #666666;
  border-top: 0px;
  margin-bottom: 24px; }

#showingItems {
  display: inline-flex;
  align-self: center;
  padding-top: 10px;
  padding-left: 25px; }

.left {
  float: left;
  padding-left: 1px; }

.bwc-modal.conflictResolution .bwc-modal-footer {
  margin-top: 0px; }
`, "",{"version":3,"sources":["webpack://./src/components/modals/resolveConflicts.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB,EAAE;;AAExB;EACE,gBAAgB,EAAE;;AAEpB;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB,EAAE;;AAEpB;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,mBAAmB,EAAE;;AAEvB;EACE,WAAW;EACX,gBAAgB,EAAE;;AAEpB;EACE,oBAAoB,EAAE;;AAExB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc,EAAE;;AAElB;EACE,UAAU;EACV,qBAAqB,EAAE;;AAEzB;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,oBAAoB,EAAE;;AAExB;EACE,yBAAyB;EACzB,eAAe;EACf,mBAAmB,EAAE;;AAEvB;EACE,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB,EAAE;;AAEtB;EACE,WAAW;EACX,iBAAiB,EAAE;;AAErB;EACE,eAAe,EAAE","sourcesContent":[".checkbox {\n  padding-bottom: 15px; }\n\n.conflictResolutionContent {\n  overflow: hidden; }\n\n#coloredContainer {\n  display: inline-flex;\n  width: 100%;\n  height: 54px;\n  background-color: #f9f9f9;\n  margin-bottom: 15px;\n  max-width: 558px; }\n\n#conflictingItemIcon {\n  position: relative;\n  top: 10px;\n  left: 8px;\n  padding-right: 12px; }\n\n#conflictItemName {\n  width: 100%;\n  padding-top: 8px; }\n\n#conflictContainer {\n  display: inline-flex; }\n\n#conflictItemDataEntry {\n  display: inline-flex;\n  padding-right: 12px;\n  font-size: 12px;\n  font-family: 'Open Sans';\n  font-weight: 400;\n  font-style: normal;\n  font-size: 12px;\n  color: #666666; }\n\n#conflictContainer {\n  width: 88%;\n  display: inline-block; }\n\n#smallerText {\n  padding-left: 20px;\n  font-family: 'Open Sans';\n  font-weight: 400;\n  font-style: normal;\n  font-size: 12px;\n  color: #666666;\n  padding-bottom: 15px; }\n\n#line {\n  border: 1px solid #666666;\n  border-top: 0px;\n  margin-bottom: 24px; }\n\n#showingItems {\n  display: inline-flex;\n  align-self: center;\n  padding-top: 10px;\n  padding-left: 25px; }\n\n.left {\n  float: left;\n  padding-left: 1px; }\n\n.bwc-modal.conflictResolution .bwc-modal-footer {\n  margin-top: 0px; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
